import { render, staticRenderFns } from "./FooterBulkActions.vue?vue&type=template&id=52570103&scoped=true&"
import script from "./FooterBulkActions.vue?vue&type=script&setup=true&lang=ts&"
export * from "./FooterBulkActions.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./FooterBulkActions.vue?vue&type=style&index=0&id=52570103&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52570103",
  null
  
)

export default component.exports